import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumber]'
})
export class OnlyNumberDirective {

  constructor(private el: ElementRef) { }

  @Input() onlyNumber: boolean;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent> event;
    if (this.onlyNumber) {
      if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode === 190) ) {
          // let it happen, don't do anything
          return;
        }
        // if (e.keyCode === 190 || e.keyCode === 18) {
        //   e.preventDefault();
        //   //return;
        // }
        // Ensure that it is a number and stop the keypress
        if (  ((e.keyCode === 190) || (e.keyCode === 18)) 
              || ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) 
              && (e.keyCode < 96 || e.keyCode > 105)) ) {
            e.preventDefault();
        }
      }
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/material/mask/restrict-onlynumbers.directive.ts